<div *ngIf="currentSubscribedProduct && currentSubscribedProduct.ProductType == 1" style="margin-bottom: 30px">
  <div
    class="subscribed-header bg-white border d-flex align-items-center justify-content-between p-3"
    [class.open]="isExpanded"
    (click)="isExpanded = !isExpanded"
  >
    <div class="d-flex align-items-center gap-3">
      <img
        class="subscribed-img"
        src="{{ currentSubscribedProduct.PrimaryImageURL | contentImage: '6' }}"
        alt="{{ currentSubscribedProduct.DisplayName }}"
      />
      <div>
        <p class="fw-bold font-size-14 mb-1">{{ currentSubscribedProduct.DisplayName }}</p>
        <span class="active-badge d-inline-flex align-items-center gap-1 px-2 py-1">
          <span class="active-dot"></span>
          <span class="font-size-12 text-success">Active</span>
        </span>
      </div>
    </div>
    <span class="subscribed-chevron" [class.rotated]="isExpanded">&rsaquo;</span>
  </div>
  <div *ngIf="isExpanded" [@expandCollapse] class="detail-panel bg-white p-3">
    <div class="d-flex flex-column align-items-start flex-lg-row flex-lg-wrap align-items-lg-center stats-row">
      <div>
        <p class="fw-bold font-size-16 mb-0">{{ daysLeft }}</p>
        <p class="font-size-12 text-muted mb-0">Days Left</p>
      </div>
      <div>
        <p class="fw-bold font-size-16 mb-0">{{ currentSubscribedProduct.NextPaymentDueDate | date: 'd MMMM yyyy' }}</p>
        <p class="font-size-12 text-muted mb-0">Next Billing Date</p>
      </div>
      <div>
        <p class="fw-bold font-size-16 mb-0">{{ currentSubscribedProduct.MerchantPrice / 100 | FortressCurrencyPipe }}</p>
        <p class="font-size-12 text-muted mb-0">Amount</p>
      </div>
      <p *ngIf="currentSubscribedProduct.MaskedPAN" class="font-size-12 text-muted ms-lg-auto text-lg-end mb-0">
        Paid with Debit/Credit Card ({{ currentSubscribedProduct.MaskedPAN | slice:-4 }})
      </p>
    </div>
    <div class="d-flex flex-column gap-1 mb-3">
      <div class="d-flex align-items-center gap-2">
        <div class="auto-renewal-toggle"
             [class.active]="autoRenewal"
             (click)="$event.stopPropagation(); toggleAutoRenewal()"
             role="switch"
             [attr.aria-checked]="autoRenewal">
          <span class="toggle-thumb"></span>
        </div>
        <span class="fw-bold font-size-14">Auto-Renewal</span>
      </div>
      <p class="font-size-14 mb-0">
        By toggling this option, your membership will automatically renew upon expiration using the card we have on file. This
        guarantees you won't miss out on any of your benefits!
      </p>
    </div>
  </div>
</div>
